import { render, staticRenderFns } from "./TaErrorForm.vue?vue&type=template&id=2367ce84&scoped=true&"
import script from "./TaErrorForm.vue?vue&type=script&lang=js&"
export * from "./TaErrorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2367ce84",
  null
  
)

export default component.exports